import React from "react";

export function GroupIcon({ vectorEffect, ...rest }: React.ComponentProps<"svg">) {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Group">
        <g id="Group_2">
          <path
            id="Vector"
            d="M18 15.0176C22.9706 15.0176 27 13.2267 27 11.0176C27 8.80844 22.9706 7.01758 18 7.01758C13.0294 7.01758 9 8.80844 9 11.0176C9 13.2267 13.0294 15.0176 18 15.0176Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_2"
            d="M9 11.0176V23.0176C9 25.2176 13 27.0176 18 27.0176C23 27.0176 27 25.2176 27 23.0176V11.0176"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_3"
            d="M27 17.0176C27 19.2176 23 21.0176 18 21.0176C13 21.0176 9 19.2176 9 17.0176"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
        </g>
        <g id="Group_3">
          <path
            id="Vector_4"
            d="M17.8 3.01755C15.463 1.5753 12.7427 0.877785 10 1.01755C5.02 1.01755 1 2.81755 1 5.01755C1 6.19755 2.16 7.25755 4 8.01755"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_5"
            d="M4 20.0176C2.16 19.2576 1 18.1976 1 17.0176V5.01758"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
          <path
            id="Vector_6"
            d="M4 14.0176C2.16 13.2576 1 12.1976 1 11.0176"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect={vectorEffect}
          />
        </g>
      </g>
    </svg>
  );
}
